export default "/50f517735fec46580f19aae3e56e9fe21614ea75/a92d826d80900dda6092d3b109ffaee1.svg";